import React from "react";
import ReactDOM from "react-dom/client";
import { Toaster } from "react-hot-toast";
import App from "./App.jsx";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        style: {
          background: "var(--bg-surface)",
          color:      "var(--text-primary)",
          border:     "1px solid var(--border)",
          fontFamily: "'Inter', system-ui, sans-serif",
          fontSize:   "13px",
        },
      }}
    />
  </React.StrictMode>
);
